/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON, FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON, } from './FxIdWebFeaturesPlayManifestRelatedApplicationsOptions';
import { FxIdWebFeaturesPlayManifestResponseIconsFromJSON, FxIdWebFeaturesPlayManifestResponseIconsToJSON, } from './FxIdWebFeaturesPlayManifestResponseIcons';
/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestResponse interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestResponse(value) {
    if (!('$Schema' in value) || value['$Schema'] === undefined)
        return false;
    if (!('Name' in value) || value['Name'] === undefined)
        return false;
    if (!('StartUrl' in value) || value['StartUrl'] === undefined)
        return false;
    if (!('Display' in value) || value['Display'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayManifestResponseFromJSON(json) {
    return FxIdWebFeaturesPlayManifestResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        '$Schema': json['$schema'],
        'Name': json['name'],
        'ShortName': json['short_name'] == null ? undefined : json['short_name'],
        'Icons': json['icons'] == null ? undefined : (json['icons'].map(FxIdWebFeaturesPlayManifestResponseIconsFromJSON)),
        'StartUrl': json['start_url'],
        'Scope': json['scope'] == null ? undefined : json['scope'],
        'Display': json['display'],
        'Id': json['id'] == null ? undefined : json['id'],
        'BackgroundColor': json['background_color'] == null ? undefined : json['background_color'],
        'Description': json['description'] == null ? undefined : json['description'],
        'Orientation': json['orientation'] == null ? undefined : json['orientation'],
        'RelatedApplications': json['related_applications'] == null ? undefined : (json['related_applications'].map(FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON)),
    };
}
export function FxIdWebFeaturesPlayManifestResponseToJSON(json) {
    return FxIdWebFeaturesPlayManifestResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayManifestResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        '$schema': value['$Schema'],
        'name': value['Name'],
        'short_name': value['ShortName'],
        'icons': value['Icons'] == null ? undefined : (value['Icons'].map(FxIdWebFeaturesPlayManifestResponseIconsToJSON)),
        'start_url': value['StartUrl'],
        'scope': value['Scope'],
        'display': value['Display'],
        'id': value['Id'],
        'background_color': value['BackgroundColor'],
        'description': value['Description'],
        'orientation': value['Orientation'],
        'related_applications': value['RelatedApplications'] == null ? undefined : (value['RelatedApplications'].map(FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayManifestResponse.js.map